/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
**/ 
 


//
// Connor's custom sticky header
//

function test_variables() {
header_settings = JSON.parse(document.querySelector('#shopify-section-header > section').getAttribute("data-section-settings"));
};



nav = document.getElementById("srs-header");
nav_height = nav.offsetHeight;
scroll_delta = 0;
scroll_position = window.scrollY;
position = 0;


function calculate_scroll_delta() {
    scroll_delta = window.scrollY - scroll_position;
    scroll_position = window.scrollY;
    return scroll_delta;
}

function control_nav() {
  	nav_height = nav.offsetHeight;
  	if (window.scrollY > header_settings["SrsHeaderThreshold"] ) {
    if (calculate_scroll_delta() > 0 ) {
        position = position - scroll_delta;
        if (position < -nav_height) {
            position = -nav_height;
            nav.style.bottom = "0px";
        }
        else {
            nav.style.bottom = -nav_height-position+"px";
        }
    }
    else {
        position = position + -scroll_delta;
        nav.style.bottom = -nav_height-position+"px";
        if (position > 0) {
            nav.style.bottom = -nav_height+"px";
            position = 0;
        }
        else {
            nav.style.bottom = -nav_height-position+"px";
        }
    }
    }
  else {
	nav.style.bottom = -nav_height+"px";
}
}


function squishy_header() {
  if (window.scrollY > header_settings["SquishyHeaderThreshold"]) {
    document.getElementById("squishy-header").classList.add("squish");
  }
  else if (window.scrollY < (header_settings["SquishyHeaderThreshold"] - 55) | window.scrollY == 0) {
    document.getElementById("squishy-header").classList.remove("squish");
  }
}


function init_srs_header() {
if (header_settings["useSrsHeader"]){
    nav.style.position = "absolute";
  if (window.scrollY > 100) {
    nav.style.bottom = "0px";
  }    else {
    nav.style.bottom = -nav_height+"px";
  }
}
}

function srs_header_check() {
  if (header_settings["useSrsHeader"] && window.getComputedStyle(document.getElementById("srs-header")).getPropertyValue('display') != "none" ){
    control_nav();
  }
};

function squishy_header_check() {
  if (header_settings["useSquishyHeader"]) {
    squishy_header();
  }
};

function init_squishy_header() {
if (header_settings["useSquishyHeader"]){
   squishy_header();
}
}


window.addEventListener('load', function (){
  	test_variables();
  	init_srs_header();
  	init_squishy_header();
  	window.addEventListener("scroll", squishy_header_check);
	window.addEventListener("scroll", srs_header_check);
  	window.addEventListener("resize", squishy_header_check);
	window.addEventListener("resize", srs_header_check);
    document.querySelector('.product-block-list__item--reviews').addEventListener('click', handler, false);
});

function throttle (callback, limit) {
    var wait = false;                  // Initially, we're not waiting
    return function () {               // We return a throttled function
        if (!wait) {                   // If we're not waiting
            callback.call();           // Execute users function
            wait = true;               // Prevent future invocations
            setTimeout(function () {   // After a period of time
                wait = false;          // And allow future invocations
            }, limit);
        }
    }
}

function myFunk() {
  if (document.querySelector(".product-block-list__item--reviews .expandable-content").getAttribute("aria-expanded") == "false") {
	document.querySelector('.product-block-list__item--reviews .expandable-content__toggle').click();
  }
}

function funky() {
	if (document.querySelector(".product-block-list__item--reviews .expandable-content").getAttribute("aria-expanded") == "true") {
      document.querySelector('.product-block-list__item--reviews .spr-form').style.display = "none";
  }
}

function handler(e) {
    if (e.target.className == 'spr-summary-actions-newreview') {
         myFunk();
    }
  else if (e.target.className == 'expandable-content__toggle' || e.target.className == 'expandable-content__toggle-icon' || e.target.className == 'expandable-content__toggle-text') {
         funky();
    }
}

function expand_quote_form (e) {
  if (document.URL.indexOf("products") >= 0) {
   if (!document.getElementById("quote-form").classList.contains('expand-form')) {
    if (window.innerWidth >= 1000 ) { 
    var y = window.scrollY;
    window.scrollTo(0,document.body.scrollHeight);
    var headerHeight = document.getElementById("squishy-header").offsetHeight;
    var navHeight = document.getElementById("srs-header").offsetHeight;
    var formPosish = e.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, y);
    var formHeight = document.getElementById("quote-form-wrapper").clientHeight;
      if ( y < formPosish-formHeight-headerHeight-30) {      
    	window.scrollTo({top: formPosish-formHeight-headerHeight-30, behavior: 'smooth'});
      } else {
        window.scrollTo({top: formPosish-formHeight-headerHeight-navHeight-30, behavior: 'smooth'});
      }
    } else {
      var offset = document.getElementById("shopify-section-header").offsetHeight + 10;
      window.scrollTo({top: e.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth'});
    }
   }
  }
  document.getElementById("quote-form").classList.toggle("expand-form");
}


function scroll_to_shipping () {
  document.getElementById('shipping-estimator-container').scrollIntoView({behavior: "smooth", block: "center"});
  document.getElementById('shipping-estimator-container').classList.remove('glow');
  setTimeout( function () {
    document.getElementById('shipping-estimator-container').classList.add('glow');
    }, 10);
}

var posish1 = 0;
var posish2 = 0;
var posish3 = 0;

function getWidth() {
return Math.max(
document.body.scrollWidth,
document.documentElement.scrollWidth,
document.body.offsetWidth,
document.documentElement.offsetWidth,
document.documentElement.clientWidth
);
}


function callback(mutationsList) {
	mutationsList.forEach(mutation => {
		if (mutation.attributeName === 'aria-expanded') {
			if (getWidth() <= 640 ) {            
				if (document.querySelector('.header__mobile-nav-toggle').getAttribute("aria-expanded") == 'true' 
                    | document.querySelector('.header__action-item-link.header__account-icon').getAttribute("aria-expanded") == 'true' 
                    | document.querySelector('.header__action-item-link.header__cart-toggle').getAttribute("aria-expanded") == 'true'
                    ) {
                    if (document.querySelector('body').classList.contains("no-mobile-scroll2")){
						if (window.scrollY != 0){
                            posish = window.scrollY;
                        }
                    } else {
							posish = window.scrollY;
                    }
					document.querySelector('body').classList.add("remove-shadow");
                    document.querySelector('body').classList.add("no-mobile-scroll2");
             		document.querySelector('header').classList.remove("header--search-expanded");
              		document.querySelector('.header__search-bar-wrapper').classList.remove("is-visible");
              		document.querySelector('body').style.top = -posish+"px";
              		if (document.querySelector('.header__mobile-nav-toggle').getAttribute("aria-expanded") == 'true') {
                		document.querySelector('body').classList.add("remove-shadow2");
              		} else {
              			document.querySelector('body').classList.remove("remove-shadow2");
            		}
            	} else {
                  	document.querySelector('body').classList.remove("no-mobile-scroll2");
              		document.querySelector('body').style.removeProperty("top");
              		window.scrollTo(0, posish);
					document.querySelector('body').classList.remove("remove-shadow");
              		document.querySelector('body').classList.remove("remove-shadow2");
              		
            	}
          
			} else if (getWidth() <= 999) {
              	if (mutation.target === document.querySelector('.header__mobile-nav-toggle')) {
                    if (document.querySelector('.header__mobile-nav-toggle').getAttribute("aria-expanded") == 'true') {
						if (document.querySelector('body').classList.contains("no-mobile-scroll2")){
							if (window.scrollY != 0){
                            	posish = window.scrollY;
                        	}
                      	} else {
							posish = window.scrollY;
                    	}
                        document.querySelector('body').classList.add("remove-shadow");
                        document.querySelector('body').classList.add("no-mobile-scroll2");
                        document.querySelector('header').classList.remove("header--search-expanded");
                        document.querySelector('.header__search-bar-wrapper').classList.remove("is-visible");
                        document.querySelector('body').classList.add("remove-shadow2");
                        document.querySelector('body').style.top = -posish+"px";                	
                    } else {
                        document.querySelector('body').classList.remove("no-mobile-scroll2");
                        document.querySelector('body').style.removeProperty("top");
                        window.scrollTo(0, posish);
                        document.querySelector('body').classList.remove("remove-shadow");
                        document.querySelector('body').classList.remove("remove-shadow2");

                    }
              	}
            }
        }
    })
}

function callback2(mutationsList) {
    mutationsList.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        if (document.querySelector('header').classList.contains("header--search-expanded")) {
            document.querySelector('.header__action-item-link.header__search-toggle').setAttribute("aria-expanded", "true");
      } else {
        document.querySelector('.header__action-item-link.header__search-toggle').setAttribute("aria-expanded", "false");
      }    
      }
})
}

const mutationObserver = new MutationObserver(callback)

const mutationObserver2 = new MutationObserver(callback2)

mutationObserver.observe(
    document.querySelector('.header__mobile-nav-toggle'),
    { attributes: true }
)

//mutationObserver.observe(
//    document.querySelector('.header__action-item-link.header__search-toggle'),
//    { attributes: true }
//)

mutationObserver.observe(
    document.querySelector('.header__action-item-link.header__account-icon'),
    { attributes: true }
)

mutationObserver.observe(
    document.querySelector('.header__action-item-link.header__cart-toggle'),
    { attributes: true }
)

mutationObserver2.observe(
    document.querySelector('header'),
    { attributes: true }
)

window.addEventListener('load', (event) => {setTimeout(set_header_height_css_var, 200)});
window.addEventListener('resize', set_header_height_css_var);
window.addEventListener('scroll', set_header_height_css_var);

function set_header_height_css_var() {
  document.documentElement.style.setProperty('--header-height2', document.querySelector('#shopify-section-header').clientHeight + 'px');
}


function dumbyclick() {
  document.querySelector('.header__action-item-link.header__search-toggle').click();
}

function dumbyclick2() {
  document.querySelector('header__action-item-link.header__cart-toggle').click();
}

document.querySelector('.search-bar__close-button').addEventListener('click', dumbyclick);

